"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _textarea = _interopRequireDefault(require("britive-design-system/core/components/textarea"));

var _modalPopup = _interopRequireDefault(require("britive-design-system/core/components/modal-popup"));

var yup = _interopRequireWildcard(require("yup"));

var _useValidationHook = _interopRequireDefault(require("../../components/use-validation-hook"));

var _commonConstants = require("../../utils/common-constants");

var _constants = require("./constants");

var _action = require("../../components/spinner-overlay/action");

var _action2 = require("../../components/notification/action");

var _reactRedux = require("react-redux");

var _constants2 = require("../../packages/my-secrets/modules/secrets/all-secrets/secret-list/constants");

var _snackbar = _interopRequireDefault(require("britive-design-system/core/components/snackbar"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.secret-approval-widget-layout .secret-approval-widget-spacing:not(:last-child) {\n  margin-bottom: 2rem; }\n\n.secret-approval-widget-layout .secret-approval-widget-label {\n  margin-bottom: 0.5rem;\n  color: #393939; }\n";
  var fileName = "widg_ApprovalModal";
  var element = document.querySelector("style[data-sass-component='widg_ApprovalModal']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var ApprovalModal = function ApprovalModal(_ref) {
  var approversDetails = _ref.approversDetails,
      entityName = _ref.entityName,
      _onSubmit = _ref.onSubmit,
      onModalClose = _ref.onModalClose,
      action = _ref.action,
      approvalInfoText = _ref.approvalInfoText,
      entityType = _ref.entityType;

  var _ref2 = approversDetails || {},
      userNames = _ref2.userIds,
      groupNames = _ref2.tags,
      managerApproval = _ref2.managerApproval,
      manager = _ref2.manager;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  (0, _react.useEffect)(function () {
    var resetData = {
      justification: ''
    };
    requiredApprovalFormValidation.resetValues(resetData);
  }, []);
  var dispatch = (0, _reactRedux.useDispatch)();
  var addRequiredApprovalFormValidationSchema = yup.object({
    justification: yup.string().required(_constants2.translatedStringsForApprovalsModal.justificationRequiredValidation).trim().max(_constants.adminSecretListConstants.maxJustificationChars, _constants2.translatedStringsForApprovalsModal.justificationMaxLength)
  });
  var requiredApprovalFormValidation = (0, _useValidationHook.default)({
    initialValues: {
      justification: ''
    },
    validationSchema: addRequiredApprovalFormValidationSchema,
    onSubmit: function () {
      var _onSubmit2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
        var _response$data, response, reason, pendingApprovalReason, data, isPendingApproval;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                dispatch((0, _action.initSpinnerOverlay)({
                  open: true,
                  size: _constants.adminSecretListConstants.mediumSize,
                  message: _constants2.translatedStringsForApprovalsModal.sendingApprovalRequestMessage
                }));
                _context.next = 4;
                return _onSubmit({
                  justification: values.justification.trim()
                });

              case 4:
                dispatch((0, _action.initSpinnerOverlay)({
                  open: false
                }));
                _context.next = 18;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                response = _context.t0.response;
                reason = (response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.message) || '';
                pendingApprovalReason = '';
                data = response.data;
                isPendingApproval = (data === null || data === void 0 ? void 0 : data.errorCode) === _constants.pendingSecretErrorCode_10;

                if (isPendingApproval) {
                  onModalClose(true);
                  pendingApprovalReason = _constants2.translatedStringsForApprovalsModal.accessRequestSentMessage;
                }

                if (!isPendingApproval) {
                  setError(reason);
                }

                isPendingApproval && dispatch((0, _action2.openNotification)(_commonConstants.successNotificationType, pendingApprovalReason, true, _commonConstants.errorNotificationDuration, action !== _constants2.translatedStringsForApprovalsModal.viewAction));
                dispatch((0, _action.initSpinnerOverlay)({
                  open: false
                }));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      function onSubmit(_x) {
        return _onSubmit2.apply(this, arguments);
      }

      return onSubmit;
    }()
  });
  var requiredApprovalModalActionButtons = [{
    text: _constants2.translatedStringsForApprovalsModal.sendRequestButton,
    variant: _constants.adminSecretListConstants.priVariant,
    onClick: function onClick() {
      requiredApprovalFormValidation.handleSubmit();
    },
    size: _constants.adminSecretListConstants.largeSize
  }, {
    text: _constants2.translatedStringsForApprovalsModal.cancelText,
    variant: _constants.adminSecretListConstants.secVariant,
    onClick: onModalClose,
    size: _constants.adminSecretListConstants.largeSize
  }];

  var renderLabel = function renderLabel() {
    var condition = managerApproval === null || managerApproval === void 0 ? void 0 : managerApproval.condition;

    if (condition === 'All' || condition === 'Any') {
      var approverType = condition === 'All' ? 'AND' : 'OR';
      return "This request must be approved by Manager ".concat(approverType, " Approvers");
    }

    if (condition === 'Manager') {
      return 'This request must be  approved by';
    }

    return 'This request must be approved by:';
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_modalPopup.default, {
    width: 512,
    title: "".concat(entityName, " (").concat(action, ")"),
    buttons: requiredApprovalModalActionButtons,
    onCancel: onModalClose
  }, !(0, _lodash.isEmpty)(error) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_snackbar.default, {
    errorList: [error]
  }), /*#__PURE__*/_react.default.createElement("br", null)), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretApprovalLayout
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretApprovalSpacing
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretApprovalSpacing
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, _constants2.translatedStringsForApprovalsModal.needApproval, " ", entityType, ".")), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretApprovalLabel
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, renderLabel())), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretApprovalSpacing
  }, !(0, _lodash.isEmpty)(managerApproval) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretApprovalLabel
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, 'Manager')), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, "- ", manager)), /*#__PURE__*/_react.default.createElement("br", null)), ((userNames === null || userNames === void 0 ? void 0 : userNames.length) || (groupNames === null || groupNames === void 0 ? void 0 : groupNames.length)) > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretApprovalLabel
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, 'Approvers')), userNames && (userNames === null || userNames === void 0 ? void 0 : userNames.map(function (user) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: user,
      className: _constants.classes.secretApprovalLabel
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "label1"
    }, " - ", user, " "));
  })), groupNames && (groupNames === null || groupNames === void 0 ? void 0 : groupNames.map(function (group) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: group,
      className: _constants.classes.secretApprovalLabel
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "label1"
    }, " - ", group, " "));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretApprovalSpacing
  }, /*#__PURE__*/_react.default.createElement(_textarea.default, {
    type: "text",
    label: _constants2.translatedStringsForApprovalsModal.justificationText,
    value: requiredApprovalFormValidation.values.justification,
    onChange: function onChange(e) {
      // Removed HTML tags using regex
      var sanitizedInput = e.target.value.replace(/<\/?[^>]+(>|$)/g, '');
      requiredApprovalFormValidation.handleChange(requiredApprovalFormValidation.names.justification, sanitizedInput);
    },
    onBlur: function onBlur() {
      requiredApprovalFormValidation.handleBlur(requiredApprovalFormValidation.names.justification);
    },
    error: requiredApprovalFormValidation.touched.justification && Boolean(requiredApprovalFormValidation.errors.justification),
    errorMsg: requiredApprovalFormValidation.errors.justification
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretApprovalLabel
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, approvalInfoText || _constants2.translatedStringsForApprovalsModal.notifiedText)), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.secretApprovalLabel
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, _constants2.translatedStringsForApprovalsModal.trackText))))));
};

ApprovalModal.propTypes = {
  entityName: _propTypes.default.string.isRequired,
  action: _propTypes.default.string.isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  onModalClose: _propTypes.default.func.isRequired,
  approversDetails: _propTypes.default.object,
  approvalInfoText: _propTypes.default.node,
  entityType: _propTypes.default.string.isRequired
};
var _default = ApprovalModal;
exports.default = _default;